import { configureStore } from '@reduxjs/toolkit';

import uploadImageSlice from './slice/uploadImage/uploadImageSlice';
import deleteImageSlice from './slice/uploadImage/deleteImageSlice';
import addBrandSlice from './slice/brand/addBrandSlice';
import updateBrandSlice from './slice/brand/updateBrandSlice';
import deleteBrandSlice from './slice/brand/deleteBrandSlice';
import getBrandListSlice from './slice/brand/getBrandListSlice';
import addCategorySlice from './slice/category/addCategorySlice';
import updateCategorySlice from './slice/category/updateCategorySlice';
import deleteCategorySlice from './slice/category/deleteCategorySlice';
import getCategoryListSlice from './slice/category/getCategoryListSlice';
import addUnitSlice from './slice/unit/addUnitSlice';
import updateUnitSlice from './slice/unit/updateUnitSlice';
import deleteUnitSlice from './slice/unit/deleteUnitSlice';
import getUnitListSlice from './slice/unit/getUnitListSlice';
import getUnitByIdSlice from './slice/unit/getUnitByIdSlice';

import addWarehouseSlice from './slice/warehouse/addWarehouseSlice';
import updateWarehouseSlice from './slice/warehouse/updateWarehouseSlice';
import deleteWarehouseSlice from './slice/warehouse/deleteWarehouseSlice';
import getWarehouseListSlice from './slice/warehouse/getWarehouseListSlice';
import addCompanySlice from './slice/company/addCompanySlice';
import updateCompanySlice from './slice/company/updateCompanySlice';
import getCompanySlice from './slice/company/getCompanySlice';
import addSupplierSlice from './slice/supplier/addSupplierSlice';
import updateSupplierSlice from './slice/supplier/updateSupplierSlice';
import deleteSupplierSlice from './slice/supplier/deleteSupplierSlice';
import getSupplierListSlice from './slice/supplier/getSupplierListSlice';
import getSupplierByWarehouseIdSlice from './slice/supplier/getSupplierByWarehouseIdSlice';
import addVariationMasterSlice from './slice/variationMaster/addVariationMasterSlice';
import updateVariationMasterSlice from './slice/variationMaster/updateVariationMasterSlice';
import deleteVariationMasterSlice from './slice/variationMaster/deleteVariationMasterSlice';
import getVariationMasterListSlice from './slice/variationMaster/getVariationMasterListSlice';
import addProductMasterSlice from './slice/productMaster/addProductMasterSlice';
import updateProductMasterSlice from './slice/productMaster/updateProductMasterSlice';
import deleteProductMasterSlice from './slice/productMaster/deleteProductMasterSlice';
import getProductMasterListSlice from './slice/productMaster/getProductMasterListSlice';
import getVariationMasterByIdSlice from './slice/variationMaster/getVariationMasterByIdSlice';
import getProductMasterByIdSlice from './slice/productMaster/getProductMasterByIdSlice';
import getProductMasterBySupplierIdSlice from './slice/productMaster/getProductMasterBySupplierIdSlice';
import addWarehouseStockSlice from './slice/warehouseStock/addWarehouseStockSlice';
import updateWarehouseStockSlice from './slice/warehouseStock/updateWarehouseStockSlice';
import deleteWarehouseStockSlice from './slice/warehouseStock/deleteWarehouseStockSlice';
import getWarehouseStockListSlice from './slice/warehouseStock/getWarehouseStockListSlice';
import warehouseStockSearchSlice from './slice/warehouseStock/warehouseStockSearchSlice';
import addPurchaseOrderSlice from './slice/purchaseOrder/addPurchaseOrderSlice';
import updatePurchaseOrderSlice from './slice/purchaseOrder/updatePurchaseOrderSlice';
import deletePurchaseOrderSlice from './slice/purchaseOrder/deletePurchaseOrderSlice';
import getPurchaseOrderListSlice from './slice/purchaseOrder/getPurchaseOrderListSlice';
import getPurchaseOrderByIdSlice from './slice/purchaseOrder/getPurchaseOrderByIdSlice';
import addPurchaseOrderInvoiceSlice from './slice/purchaseOrderInvoice/addPurchaseOrderInvoiceSlice';
import updatePurchaseOrderInvoiceSlice from './slice/purchaseOrderInvoice/updatePurchaseOrderInvoiceSlice';
import deletePurchaseOrderInvoiceSlice from './slice/purchaseOrderInvoice/deletePurchaseOrderInvoiceSlice';
import getPurchaseOrderInvoiceListSlice from './slice/purchaseOrderInvoice/getPurchaseOrderInvoiceListSlice';
import getPurchaseOrderInvoiceByIdSlice from './slice/purchaseOrderInvoice/getPurchaseOrderInvoiceByIdSlice';
import salesSlice from './slice/sales/salesSlice';
import loginSlice from './slice/login/loginSlice';
import userSlice from './slice/user/userSlice';
import getRolesListSlice from './slice/Roles/getRolesListSlice';
import addRolesSlice from './slice/Roles/addRolesSlice';
import deleteRoleSlice from './slice/Roles/deleteRolesSlice';
import addUserSlice from './slice/user/addUserSlice';
import updateUserSlice from './slice/user/updateUserSlice';
import deleteUserSlice from './slice/user/deleteUserSlice';
import getExpenseCategoryListSlice from './slice/expenseCategory/getExpenseCategoryListSlice';
import addExpCategorySlice from './slice/expenseCategory/addExpenseCategorySlice';
import updateExpenseCategorySlice from './slice/expenseCategory/updateExpenseCategorySlice';
import deleteExpCategorySlice from './slice/expenseCategory/deleteExpenseCategorySlice';
import getExpensesListSlice from './slice/expenses/getExpensesListSlice';
import addExpenseSlice from './slice/expenses/addExpenseSlice';
import updateExpenseSlice from './slice/expenses/updateExpenseSlice';
import deleteExpenseSlice from './slice/expenses/deleteExpenseSlice';
import getCustomerListSlice from './slice/customers/getCustomerListSlice';
import addCustomerSlice from './slice/customers/addCustomerSlice';
import updateCustomerSlice from './slice/customers/updateCustomerSlice';
import deleteCustomerSlice from './slice/customers/deleteCustomerSlice';
import getBatchListSlice from './slice/batch/getBatchListSlice';
import addBatchSlice from './slice/batch/addBatchSlice';
import updateBatchSlice from './slice/batch/updateBatchApi';
import deleteBatchSlice from './slice/batch/deleteBatchSlice';
import getTerminalMastersListSlice from './slice/terminalMaster/getTerminalMastersListSlice';
import addTerminalMasterSlice from './slice/terminalMaster/addTerminalMasterSlice';
import updateTerminalMasterSlice from './slice/terminalMaster/updateTerminalMasterSlice';
import deleteTerminalSlice from './slice/terminalMaster/deleteTerminalMasterApi';
import getShiftSlice from './slice/shift/getShiftSlice';
import addShiftSlice from './slice/shift/addShiftSlice';
import updateShiftSlice from './slice/shift/updateShiftSlice';
import deleteShiftSlice from './slice/shift/deleteShiftSlice';
import getCheckInOutSlice from './slice/checkInOut/getCheckInOutSlice';
import addCheckInOutSlice from './slice/checkInOut/addCheckInOutSlice';
import updateCheckInOutSlice from './slice/checkInOut/updateCheckInOut';
import deleteCheckInOutSlice from './slice/checkInOut/deleteCheckInOutSlice';
import addProductPackageSlice from './slice/productPackage/addProductPackageSlice';
import updateProductPackageSlice from './slice/productPackage/updateProductPackageSlice';
import deleteProductPackageSlice from './slice/productPackage/deleteProductPackageSlice';
import getProductPackageListSlice from './slice/productPackage/getProductPackageListSlice';
import getProductPackageByIdSlice from './slice/productPackage/getProductPackageByIdSlice';
import getCustomerSchedulePackageSlice from './slice/customerSchedulePackage/getCustomerSchedulePackageSlice';
import addCustomerSchedulePackageSlice from './slice/customerSchedulePackage/addCustomerSchedulePackageSlice';
import updateCustomerSchedulePackageSlice from './slice/customerSchedulePackage/updateCustomerSchedulePackageSlice';
import deleteCustomerSchedulePakageslice from './slice/customerSchedulePackage/deleteCustomerSchedulePakageslice';
import updateRoleListSlice from './slice/Roles/updateRoleListSlice';

export const store = configureStore({
  reducer: {
    uploadImageState: uploadImageSlice,
    deleteImageState: deleteImageSlice,
    addBrandState: addBrandSlice,
    getBrandListState: getBrandListSlice,
    updateBrandState: updateBrandSlice,
    deleteBrandState: deleteBrandSlice,
    addCategoryState: addCategorySlice,
    getCategoryListState: getCategoryListSlice,
    updateCategoryState: updateCategorySlice,
    deleteCategoryState: deleteCategorySlice,
    addUnitState: addUnitSlice,
    getUnitListState: getUnitListSlice,
    getUnitByIdState: getUnitByIdSlice,
    updateUnitState: updateUnitSlice,
    deleteUnitState: deleteUnitSlice,
    addWarehouseState: addWarehouseSlice,
    getWarehouseListState: getWarehouseListSlice,
    updateWarehouseState: updateWarehouseSlice,
    deleteWarehouseState: deleteWarehouseSlice,
    addCompanyState: addCompanySlice,
    getCompanyState: getCompanySlice,
    updateCompanyState: updateCompanySlice,
    addSupplierState: addSupplierSlice,
    getSupplierListState: getSupplierListSlice,
    getSupplierByWarehouseIdState: getSupplierByWarehouseIdSlice,
    updateSupplierState: updateSupplierSlice,
    deleteSupplierState: deleteSupplierSlice,
    addVariationMasterState: addVariationMasterSlice,
    getVariationMasterListState: getVariationMasterListSlice,
    getVariationMasterByIdState: getVariationMasterByIdSlice,
    updateVariationMasterState: updateVariationMasterSlice,
    deleteVariationMasterState: deleteVariationMasterSlice,
    addProductMasterState: addProductMasterSlice,
    getProductMasterListState: getProductMasterListSlice,
    updateProductMasterState: updateProductMasterSlice,
    deleteProductMasterState: deleteProductMasterSlice,
    getProductMasterByIdState: getProductMasterByIdSlice,
    getProductMasterBySupplierIdState: getProductMasterBySupplierIdSlice,
    addWarehouseStockState: addWarehouseStockSlice,
    getWarehouseStockListState: getWarehouseStockListSlice,
    updateWarehouseStockState: updateWarehouseStockSlice,
    deleteWarehouseStockState: deleteWarehouseStockSlice,
    warehouseStockSearchState: warehouseStockSearchSlice,
    addPurchaseOrderState: addPurchaseOrderSlice,
    getPurchaseOrderListState: getPurchaseOrderListSlice,
    updatePurchaseOrderState: updatePurchaseOrderSlice,
    deletePurchaseOrderState: deletePurchaseOrderSlice,
    getPurchaseOrderByIdState: getPurchaseOrderByIdSlice,
    addPurchaseOrderInvoiceState: addPurchaseOrderInvoiceSlice,
    getPurchaseOrderInvoiceListState: getPurchaseOrderInvoiceListSlice,
    updatePurchaseOrderInvoiceState: updatePurchaseOrderInvoiceSlice,
    deletePurchaseOrderInvoiceState: deletePurchaseOrderInvoiceSlice,
    getPurchaseOrderInvoiceByIdState: getPurchaseOrderInvoiceByIdSlice,
    salesState: salesSlice,
    loginState: loginSlice,
    userState: userSlice,
    addUserState: addUserSlice,
    updateUserState: updateUserSlice,
    deleteUserState: deleteUserSlice,
    getRolesListState: getRolesListSlice,
    addRolesState: addRolesSlice,
    deleteRoleState: deleteRoleSlice,
    getExpenseCategoryListState: getExpenseCategoryListSlice,
    addExpCategoryState: addExpCategorySlice,
    updateExpenseCategoryState: updateExpenseCategorySlice,
    deleteExpCategoryState: deleteExpCategorySlice,
    getExpensesListState: getExpensesListSlice,
    addExpenseState: addExpenseSlice,
    updateExpenseState: updateExpenseSlice,
    deleteExpenseState: deleteExpenseSlice,
    getCustomerListState: getCustomerListSlice,
    addCustomerState: addCustomerSlice,
    updateCustomerState: updateCustomerSlice,
    deleteCustomerState: deleteCustomerSlice,
    getBatchListState: getBatchListSlice,
    addBatchState: addBatchSlice,
    updateBatchState: updateBatchSlice,
    deleteBatchState: deleteBatchSlice,
    getTerminalMasterState: getTerminalMastersListSlice,
    addTerminalMasterState: addTerminalMasterSlice,
    updateTerminalState: updateTerminalMasterSlice,
    deleteTerminalState: deleteTerminalSlice,
    getShiftState: getShiftSlice,
    addShiftState: addShiftSlice,
    updateShiftState: updateShiftSlice,
    deleteShiftState: deleteShiftSlice,
    getCheckInOutState: getCheckInOutSlice,
    addCheckInOutState: addCheckInOutSlice,
    updateCheckInOutState: updateCheckInOutSlice,
    deleteCheckInOutState: deleteCheckInOutSlice,
    getCustomerScheduleState: getCustomerSchedulePackageSlice,
    addCustomerSchedulePackageState: addCustomerSchedulePackageSlice,
    updateCustomerSchedulePackageState: updateCustomerSchedulePackageSlice,
    deleteCustomerScheduleState: deleteCustomerSchedulePakageslice,
    addProductPackageState: addProductPackageSlice,
    getProductPackageListState: getProductPackageListSlice,
    updateProductPackageState: updateProductPackageSlice,
    deleteProductPackageState: deleteProductPackageSlice,
    getProductPackageByIdState: getProductPackageByIdSlice,
    updateRoleListState: updateRoleListSlice,
  },
});
